import { Title } from '@mantine/core';
import { SignInForm } from '@medplum/react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';

export function SignInPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <SignInForm
      // Configure according to your settings
      googleClientId="245329440992-ggndq363eeiak85dlvfm79osaests301.apps.googleusercontent.com"
      onSuccess={() => navigate('/')}
    >
      <Logo width={200} />
      <Title>sign in</Title>
    </SignInForm>
  );
}